import React                      from "react";
import { StyleSheet, View, Text } from "react-native";
import Row                        from "../../../layouts/Row";
import Col                        from "../../../layouts/Col";
import Heading                    from "../../Heading/index";
import SolidButton                from "../../Buttons/SolidButton/index";
import palette                    from "../../../styles/palette";
import StyledInput                from "../../StyledInput/index";

export default function CallsHeader() {
  return (
    <View style={[styles.customers_header__container]}>
      <View style={[styles.customers_header__inner]}>
        <Row pl={16} pr={16} style={{ height: "100%" }}>
          <Col leftCenter>
            <Heading size={1}>Calls</Heading>
          </Col>
          <Col rightCenter></Col>
        </Row>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  customers_header__container: {
    borderBottomWidth: 1,
    borderBottomColor: palette.light_grey,
    backgroundColor: palette.primary_dark,
  },
  customers_header__inner: {
    backgroundColor: palette.white,
    height: 75,
    borderTopLeftRadius: 16,
  },
  customers_header__search_input: {
    width: 380,
    backgroundColor: palette.lightest_grey,
    fontSize: 18,
    paddingHorizontal: 24,
    borderRadius: 24,
  },
  context_header__count_text: {
    color: palette.grey,
    fontSize: 16,
  },
});
